import { createDefaultTyrann } from '@apis/common';
import { dashboardMemberQuery, member } from '@models/Member';
import * as t from 'io-ts';

export const memberApis = createDefaultTyrann({
  '/dashboard/member/': {
    get: {
      query: dashboardMemberQuery,
      response: {
        200: t.type({
          count: t.number,
          results: t.array(member),
        }),
      },
    },
  },
});
